import { render } from "./CustomeFavoriteProducts.vue?vue&type=template&id=c4bf1e58&scoped=true&ts=true"
import script from "./CustomeFavoriteProducts.vue?vue&type=script&lang=ts"
export * from "./CustomeFavoriteProducts.vue?vue&type=script&lang=ts"

import "./CustomeFavoriteProducts.vue?vue&type=style&index=0&id=c4bf1e58&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4bf1e58"]])

export default __exports__